import React from 'react';

import Card from '../../components/common/Card';
import AdminLayout from '../../components/layout/AdminLayout';
import CoursesPlayedRanking from '../../components/member/CoursesPlayedRanking';

// The desktop page for the member's played courses. The list itself (ranking, Played switch,
// add, share) is CoursesPlayedRanking, which is also the Courses tab of the profile's golf lists,
// the phone's way in.
const CoursesPlayed: React.FC = () => (
  <AdminLayout
    activeMenuItem="/member/courses-played"
    breadcrumbs={[
      { label: 'My Profile', href: '/member/profile' },
      { label: 'Courses Played', href: '#' },
    ]}
    allowedRoles={['User']}
  >
    <Card title="Courses Played">
      <CoursesPlayedRanking />
    </Card>
  </AdminLayout>
);

export default CoursesPlayed;
